import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserProfileInfo } from 'api/user';

export interface CurrentUserProfileSliceState {
  data: UserProfileInfo | null;
  error: null | string;
  loading: boolean;
}

const INITIAL_STATE: CurrentUserProfileSliceState = {
  data: null,
  error: null,
  loading: false,
};

export const slice = createSlice({
  name: 'currentUserProfile',
  initialState: INITIAL_STATE,

  reducers: (create) => ({
    start: create.reducer((state: CurrentUserProfileSliceState) => {
      return { ...state, loading: true };
    }),

    success: create.reducer(
      (
        state: CurrentUserProfileSliceState,
        action: PayloadAction<UserProfileInfo>,
      ) => {
        return {
          ...state,
          loading: false,
          error: null,
          data: {
            ...state.data,
            ...action.payload,
          },
        };
      },
    ),
  }),
});
